/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './Participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
    ParticipantToJSONTyped,
} from './Participant';

/**
 * 
 * @export
 * @interface UpdateMyLearnVisitRequest
 */
export interface UpdateMyLearnVisitRequest {
    /**
     * 
     */
    participants?: Array<Participant>;
    /**
     * 
     */
    teamName?: string | null;
}

/**
 * Check if a given object implements the UpdateMyLearnVisitRequest interface.
 */
export function instanceOfUpdateMyLearnVisitRequest(value: object): value is UpdateMyLearnVisitRequest {
    return true;
}

export function UpdateMyLearnVisitRequestFromJSON(json: any): UpdateMyLearnVisitRequest {
    return UpdateMyLearnVisitRequestFromJSONTyped(json, false);
}

export function UpdateMyLearnVisitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMyLearnVisitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'participants': json['participants'] == null ? undefined : ((json['participants'] as Array<any>).map(ParticipantFromJSON)),
        'teamName': json['team_name'] === undefined ? undefined : json['team_name'] === null ? null : json['team_name'],
    };
}

export function UpdateMyLearnVisitRequestToJSON(json: any): UpdateMyLearnVisitRequest {
    return UpdateMyLearnVisitRequestToJSONTyped(json, false);
}

export function UpdateMyLearnVisitRequestToJSONTyped(value?: UpdateMyLearnVisitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participants': value['participants'] == null ? undefined : ((value['participants'] as Array<any>).map(ParticipantToJSON)),
        'team_name': value['teamName'],
    };
}

